import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { IProductProcessData } from "common/records/ProductProcess";

export const FETCH_PROCESSES = "@productProcesses/FETCH_PROCESSES";
export const RECEIVE_PROCESSES = "@productProcesses/RECEIVE_PROCESSES";
export const RECEIVE_PROCESS_ERRORS = "@productProcesses/RECEIVE_PROCESS_ERRORS";

export const ProductProcessActions = {
  fetchProcesses: () => createAction(FETCH_PROCESSES),
  receiveProcesses: (processes: Partial<IProductProcessData>) => createAction(RECEIVE_PROCESSES, processes),
  receiveProcessErrors: (errors: string[]) => createAction(RECEIVE_PROCESS_ERRORS, errors),
};

export type ProductProcessActions = ActionsUnion<typeof ProductProcessActions>;
